import Layout from '@/layout'
import MenuMain from '@/layout/components/MenuMain'

export const routerList = [
  {
    path: '/finance',
    component: Layout,
    meta: {
      title: '财务',
      icon: 'icon-chanpinPIguanli-01'
    },
    alwaysShow: true,
    children: [
      {
        path: '/finance/imprest',
        component: () => import('@/views/Finance/Imprest'),
        name: 'FinanceImprest',
        meta: { title: '备用金', affix: false }
      }, 
      {
        path: '/finance/imprest/detail',
        component: () => import('@/views/Finance/ImprestDetail'),
        name: 'FinanceImprestDetail',
        meta: { title: '备用金详情', affix: false },
        hidden: true
      },
      // {
      //   path: '/finance/receipt',
      //   component: () => import('@/views/Finance/Index'),
      //   name: 'FinanceReceipt',
      //   meta: { title: '收款单', affix: false }
      // }, 
      {
        path: '/finance/labor',
        component: () => import('@/views/Finance/Labor'),
        name: 'FinanceLabor',
        meta: { title: '人工费', affix: false }
      }, 
      {
        path: '/finance/labor/detail',
        component: () => import('@/views/Finance/LaborDetail'),
        name: 'FinanceLaborDetail',
        meta: { title: '人工费详情', affix: false },
        hidden: true
      },
      {
        path: '/finance/material',
        component: () => import('@/views/Finance/Material'),
        name: 'FinanceMaterial',
        meta: { title: '材料费', affix: false }
      }, 
      {
        path: '/finance/material/detail',
        component: () => import('@/views/Finance/MaterialDetail'),
        name: 'FinanceMaterialDetail',
        meta: { title: '材料费详情', affix: false },
        hidden: true
      },
      {
        path: '/finance/payment',
        component: () => import('@/views/Finance/Payment'),
        name: 'FinancePayment',
        meta: { title: '付款单', affix: false },
      },
      {
        path: '/finance/payment/cost-type',
        component: { render: c => c('router-view') },
        meta: { title: '付款单分类', affix: false },
        alwaysShow: true,
        children: []
      },
      {
        path: '/finance/payment/detail',
        component: () => import('@/views/Finance/PaymentDetail'),
        name: 'FinancePaymentDetail',
        meta: { title: '付款单详情', affix: false },
        hidden: true
      },
      {
        path: '/finance/reimbursement',
        component: () => import('@/views/Finance/Reimbursement'),
        name: 'FinanceReimbursement',
        meta: { title: '报销单', affix: false }
      },
      {
        path: '/finance/reimbursement/detail',
        component: () => import('@/views/Finance/ReimbursementDetail'),
        name: 'FinanceReimbursementDetail',
        meta: { title: '报销单详情', affix: false },
        hidden: true
      },
      {
        path: '/finance/leaderReimb',
        component: () => import('@/views/Finance/LeaderReimb'),
        name: 'FinanceLeaderReimb',
        meta: { title: '领导报销单', affix: false }
      },
      {
        path: '/finance/leaderReimb/detail',
        component: () => import('@/views/Finance/LeaderReimbDetail'),
        name: 'FinanceLeaderReimbDetail',
        meta: { title: '领导报销单详情', affix: false },
        hidden: true
      },
      {
        path: '/finance/verification',
        component: () => import('@/views/Finance/Verification'),
        name: 'FinanceVerification',
        meta: { title: '核销', affix: false }
      },
      {
        path: '/finance/verification/detail',
        component: () => import('@/views/Finance/VerificationDetail'),
        name: 'FinanceVerificationDetail',
        meta: { title: '核销详情', affix: false },
        hidden: true
      },
      {
        path: '/finance/tax',
        component: () => import('@/views/Finance/Tax'),
        name: 'FinanceTax',
        meta: { title: '进项税费', affix: false }
      },
      {
        path: '/finance/tax/detail',
        component: () => import('@/views/Finance/TaxDetail'),
        name: 'FinanceTaxDetail',
        meta: { title: '进项税费详情', affix: false },
        hidden: true
      },
      {
        path: '/finance/settings',
        component: { render: c => c('router-view') },
        meta: { title: '财务设置', icon: 'icon-shezhi-01', affix: false },
        alwaysShow: true,
        children: [
          {
            path: '/finance/costType',
            component: () => import('@/views/Finance/CostType'),
            name: 'FinanceCostType',
            meta: { title: '费用类型设置', icon: 'icon-shezhi-01', affix: false }
          },
          {
            path: '/finance/imprestCustom',
            component: () => import('@/views/Finance/ImprestCustom'),
            name: 'FinanceImprestCustom',
            meta: { title: '备用金设置', icon: 'icon-shezhi-01', affix: false }
          }
        ]
      }
    ]
  }
]
